<template>
    <tr>
      <td class="px-1">{{ index + 1 }}</td>
        <td class="pl-10">
            <div class="col px-1">
                <strong>
                    <h6>{{ item.name }}</h6>
                </strong>
                {{ item.description }}
            </div>
        </td>

        <td @click="editingField = 'quantity'" class="text-right mx-w-50">
          <div class="d-flex justify-content-end">
            <input
              v-if="editingField === 'quantity' && ! route.params.invoiceId"
              v-model.number="item.quantity"
              type="number"
              class="form-control text-right mx-w-70"
              @blur="editingField = null"
              v-focus
            >
            <span class="px-1" v-else>{{ item.quantity }}</span>
          </div>
        </td>

        <td @click="editingField = 'rate'" class="text-right mx-w-50">
            <div class="d-flex justify-content-end">
                <input
                  v-if="editingField === 'rate'"
                  v-model.number="item.rate"
                  type="number"
                  class="form-control text-right mx-w-70"
                  @blur="editingField = null"
                  v-focus
                >
                <span class="px-1" v-else>{{ item.rate }}</span>
            </div>
        </td>

        <td class="text-right px-1 mx-w-50">{{ totalAmount }}</td>
        <td v-if="! route.params.invoiceId" class="th-action">
            <div>
                <button @click="deleteItem(index)" class="btn btn-sm btn-dlt">
                    <i class="fas fa-trash"></i>
                </button>
            </div>
        </td>
    </tr>
</template>
<script setup>
import { computed, ref } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();

const props = defineProps(['item', 'index', 'onDeleteItem', 'tableItems'])
const emit = defineEmits(['onDeleteItem']);

const editingField = ref(null);

const vFocus = {
    mounted(el) {
        el.focus();
    }
};

const deleteItem = (i) => {
    emit('onDeleteItem', i)
}
const totalAmount = computed(() => props.item.total_amount = props.item.amount = props.item.rate * props.item.quantity);
</script>
<style scoped>
.btn-dlt{
    color: #ea5455;
}
.mx-w-50 {
    max-width: 50px;
}
.th-action {
    max-width: 20px;
}
.mx-w-70 {
    max-width: 70px;
}
</style>